import "../../App.css";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function DoctorScheduleTimings() {
  const WeekDay = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const [Weekdayactive, setWeekdayActive] = useState(null);
  const [TimeSlot, setTimeSlot] = useState([]);
  const [TimeSlotactive, setTimeSlotActive] = useState([]);
  const [SaveText, setSaveText] = useState(false);
  const [showTransaction, setShowTransaction] = useState(true);
  const [isSavingTransaction, setIsSavingTransaction] = useState(false);
  let navigate = useNavigate();

  const clinicId = localStorage.getItem("clinicId");
  const doctorId = localStorage.getItem("doctorId");

  useEffect(() => {
    setSaveText(false);
    var Url = window.API_PREFIX + "timing/showslot_advance_doctor";
    fetch(Url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
        Tag: 0,
        ClinicId: parseInt(clinicId, 10),
        loginAs: "Doctor",
        doctorId: parseInt(doctorId, 10),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data["status"] === "Block") {
          toast.error(data["message"]);
          localStorage.clear();
          navigate("/doctor");
          window.location.reload();
        } else if (data["status"] === "1") {
          setTimeSlot([...data["TotalSlot"]]);
          setTimeSlotActive([...data["ActiveSlot"]]);
        } else {
          toast.error(data["message"] || "Could not load slots");
        }
      });

    fetch(window.API_PREFIX + "admin/doctordetail", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Token: localStorage.getItem("DToken"),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data["status"] === "1") {
          const isOn = Number(data?.data?.ShowTransaction || 0) === 1;
          setShowTransaction(isOn);
          localStorage.setItem("doctorShowTransaction", isOn ? "1" : "0");
        }
      });
    setWeekdayActive("Monday");
  }, []);

  return (
    <div className="container-fuild mx-2">
      <div className="schedule_timings_main_diviison">
        <div className="schedule_timings_diviison">
          <div className="d-flex justify-content-end align-items-center mb-3">
            <label className="form-check form-switch m-0">
              <input
                className="form-check-input"
                type="checkbox"
                checked={showTransaction}
                disabled={isSavingTransaction}
                onChange={(e) => {
                  const nextValue = e.target.checked;
                  setShowTransaction(nextValue);
                  setIsSavingTransaction(true);

                  const fd = new FormData();
                  fd.append("Token", localStorage.getItem("DToken"));
                  fd.append("ShowTransaction", nextValue ? "1" : "0");

                  fetch(window.API_PREFIX + "admin/update_doctor_profile", {
                    method: "POST",
                    body: fd,
                  })
                    .then((resp) => resp.json())
                    .then((data) => {
                      if (data["status"] === "Block") {
                        toast.error(data["message"]);
                        localStorage.clear();
                        navigate("/doctor");
                        window.location.reload();
                      } else if (data["status"] === "1") {
                        localStorage.setItem(
                          "doctorShowTransaction",
                          nextValue ? "1" : "0",
                        );
                        toast.success(
                          nextValue
                            ? "Transaction display enabled"
                            : "Transaction display disabled",
                        );
                      } else {
                        setShowTransaction(!nextValue);
                        toast.error(data["message"] || "Could not update setting");
                      }
                    })
                    .catch(() => {
                      setShowTransaction(!nextValue);
                      toast.error("Could not update setting");
                    })
                    .finally(() => setIsSavingTransaction(false));
                }}
              />
              <span className="ms-2 fw-semibold">
                Show Transactions in Doctor Panel
              </span>
            </label>
          </div>
          <div className="schedule_timings_week_division">
            {WeekDay.map((eachDay, DayIndex) => {
              return (
                <div
                  key={eachDay}
                  onClick={() => {
                    setSaveText(false);
                    var Url =
                      window.API_PREFIX + "timing/showslot_advance_doctor";
                    fetch(Url, {
                      method: "POST",
                      headers: {
                        "Content-type": "application/json",
                      },
                      body: JSON.stringify({
                        Token: localStorage.getItem("DToken"),
                        Tag: DayIndex,
                        ClinicId: parseInt(clinicId, 10),
                        loginAs: "Doctor",
                        doctorId: parseInt(doctorId, 10),
                      }),
                    })
                      .then((resp) => resp.json())
                      .then((data) => {
                        if (data["status"] === "Block") {
                          toast.error(data["message"]);
                          localStorage.clear();
                          navigate("/doctor");
                          window.location.reload();
                        } else if (data["status"] === "1") {
                          setTimeSlot([...data["TotalSlot"]]);
                          setTimeSlotActive([...data["ActiveSlot"]]);
                        } else {
                          toast.error(
                            data["message"] || "Could not load slots",
                          );
                        }
                      });
                    setWeekdayActive(eachDay);
                  }}
                  className={
                    Weekdayactive === eachDay
                      ? "schedule_timings_week_name_active"
                      : "schedule_timings_week_name"
                  }
                >
                  {eachDay}
                </div>
              );
            })}
          </div>
          <div className="schedule_timings_time_slot_division">
            <div className="schedule_timings_time_slote_title">time slots</div>
          </div>

          <div className="schedule_timings_time_slot_table_division">
            {TimeSlot.map((eachTimeSlot, TimeSlotindex) => {
              return (
                <div
                  key={TimeSlotindex}
                  className={
                    TimeSlotactive[TimeSlotindex]
                      ? "schedule_timings_time_slots_active"
                      : "schedule_timings_time_slots"
                  }
                  onClick={() => {
                    setSaveText(false);
                    var tmpFlag = [...TimeSlotactive];
                    tmpFlag[TimeSlotindex] = !tmpFlag[TimeSlotindex];
                    setTimeSlotActive([...tmpFlag]);
                  }}
                >
                  {eachTimeSlot}
                </div>
              );
            })}
          </div>
          <div className="schedule_timings_save_slot_button_division">
            <button
              type="button"
              className="btn schedule_timings_save_slot_button"
              onClick={() => {
                var Url = window.API_PREFIX + "timing/update_slot";
                fetch(Url, {
                  method: "POST",
                  headers: {
                    "Content-type": "application/json",
                  },
                  body: JSON.stringify({
                    Token: localStorage.getItem("DToken"),
                    DayTag: WeekDay.indexOf(Weekdayactive),
                    SlotActive: TimeSlotactive,
                    clinicId: parseInt(clinicId, 10),
                    loginAs: "Doctor",
                    doctorId: parseInt(doctorId, 10),
                  }),
                })
                  .then((resp) => resp.json())
                  .then((data) => {
                    if (data["status"] === "Block") {
                      toast.error(data["message"]);
                      localStorage.clear();
                      navigate("/doctor");
                      window.location.reload();
                    } else if (data["status"] === "1") {
                      toast.success("Saved Successfully");
                      setSaveText(true);
                    } else {
                      toast.error(data["message"] || "Save failed");
                    }
                  });
              }}
              disabled={SaveText}
            >
              {SaveText ? "Saved" : "Save Slot"}
            </button>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-3">
          <div>
            <i className="fa-solid fa-square me-2 available_1"></i>
            Availble
          </div>
          <div className="ms-3">
            <i className="fa-solid fa-square me-2 available_2"></i>
            Not Availble
          </div>
        </div>
      </div>
    </div>
  );
}

export default DoctorScheduleTimings;
